import { wrapper } from 'src/redux/store'
import ExchangeDetails from 'src/pages/ExchangeDetails'
import {
  getExchangeData,
  getRemoteMapData,
  populateFilterStore,
} from 'src/redux/thunks'
import { ENTITY } from 'src/consts'

const Exchange = ExchangeDetails

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ query, params, res }) => {
      await Promise.all([
        store.dispatch(
          getExchangeData({
            url: process.env.NEXT_PUBLIC_API_ENDPOINT,
            slug: params.slug,
          })
        ),
        store.dispatch(
          getRemoteMapData({
            entity: ENTITY.EXCHANGE,
            url: process.env.NEXT_PUBLIC_API_ENDPOINT,
          })
        ),
        store.dispatch(
          populateFilterStore({ ...query, ranking: 'all' }, ENTITY.COIN)
        ),
        store.dispatch(
          getRemoteMapData({
            entity: ENTITY.COIN,
            url: process.env.NEXT_PUBLIC_API_ENDPOINT,
          })
        ),
      ])

      res.setHeader('Cache-Control', 'public, s-maxage=10')

      return {
        props: { params },
      }
    }
)

export default Exchange
